import * as Sentry from "@sentry/browser"
import { Integrations } from "@sentry/tracing"

Sentry.init({
  dsn: window.sentry_dsn,
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: window.sentry_js_sample_rate,
})

// Turbo blanks a frame with "Content missing" whenever a frame response holds
// no matching <turbo-frame> — an error page, a Heroku router error page, or a
// redirect off the search page. None of those reach server-side Sentry, so
// report the response here and recover with a full page load.
document.addEventListener(`turbo:frame-missing`, (event) => {
  const { response, visit } = event.detail

  Sentry.captureMessage(`turbo:frame-missing`, {
    level: `error`,
    extra: {
      frame: event.target.id,
      url: response.url,
      status: response.status,
      redirected: response.redirected,
    },
  })

  event.preventDefault()
  visit(response)
})
